/**
 * Read the JWT `sub` claim from a compact JWT. Signature is not verified —
 * this is only used to recover the auth user id for `/auth/refresh`.
 */
export function readJwtSubject(token: string | null | undefined): string | null {
  const raw = (token ?? '').trim();
  const parts = raw.split('.');
  if (parts.length < 2) return null;
  const payload = parts[1];
  if (!payload) return null;
  try {
    const json = decodeBase64Url(payload);
    const parsed = JSON.parse(json) as { sub?: unknown };
    if (typeof parsed.sub === 'string' && parsed.sub.trim().length > 0) {
      return parsed.sub.trim();
    }
  } catch {
    return null;
  }
  return null;
}

function decodeBase64Url(segment: string): string {
  const padded = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padLen = (4 - (padded.length % 4)) % 4;
  const b64 = `${padded}${'='.repeat(padLen)}`;
  if (typeof globalThis.atob === 'function') {
    return globalThis.atob(b64);
  }
  throw new Error('Base64 decode is not available');
}
